// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3Xx80","feedback":"Footer_feedback__319OA","text":"Footer_text__2CVKl"};